import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DiscoverPage = () => {
  const navigate = useNavigate();

  // Ensure the body background is white
  useEffect(() => {
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#fff';
    return () => {
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen bg-white p-8 w-full">
      <button
        onClick={() => navigate('/ai-agent')}
        className="absolute top-8 left-8 bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-lg shadow transition flex items-center"
        style={{ zIndex: 10 }}
      >
        <svg width="20" height="20" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24" className="mr-2">
          <path d="M15 19l-7-7 7-7" />
        </svg>
        Back to AI Agent
      </button>

      {/* Centered Logo, moved further up */}
      <img 
        src="/discover_page_arta_logo.png"
        alt="Arta Logo" 
        className="w-64 h-64 object-contain mt-10 mb-8 transform hover:scale-105 transition-transform duration-300"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "A.png";
        }}
      />

      {/* Left-aligned, wider content */}
      <div className="w-full max-w-4xl flex flex-col items-start text-left space-y-6">
        <h1 className="text-4xl font-bold text-[#253439] mb-4">About Arta Inc</h1>
        <p className="text-xl text-[#253439] leading-relaxed">
          Arta Inc is headquartered in San Jose, CA. Arta is in stealth mode. We look forward to using and enhancing AI models to bring innovative products and services to the market soon.
        </p>
        <p className="text-xl text-[#253439] leading-relaxed">
          Arta is founded by repeat entrepreneurs who have created innovative Security and Cloud products working in startups and large Enterprises. Arta founders have also created forward thinking products in the Customer Support and Solutions space.
        </p>
        <p className="text-xl text-[#253439] leading-relaxed">
          If you would like to know more, please contact us at <a href="mailto:insights@artasupport.ai" className="text-cyan-500 hover:text-cyan-600 underline">insights@artasupport.ai</a>
        </p>
      </div>
    </div>
  );
};

export default DiscoverPage; 